module.exports = __webpack_public_path__ + "static/media/5.e9467f78.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/5.wav
// module id = 89
// module chunks = 0